import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";

// css
import css from "./EnvironmentStatus.styl";

const TERMINAL_HEIGHTS = [180, 320, 460];

export const EnvironmentStatusOsxTerminal = (props) => {
	const { deploymentEvents, closeOsxTerminal } = props;
	const [terminalHeight, setTerminalHeight] = React.useState(1);

	const statusMessageContainerRef = useRef(null);

	useEffect(() => {
		if (deploymentEvents.length > 0) {
			// scroll conatiner to bottom
			statusMessageContainerRef.current.scrollTop = statusMessageContainerRef.current.scrollHeight;
		}
	}, [deploymentEvents, terminalHeight]);

	return (
		<div className={css.osxTerminal}>
			<div className={css.headBar}>
				<div />
				<div className={`${css.headButton}`}>
					<div onClick={() => closeOsxTerminal()} className={`${css.button} ${css.close}`} />
				</div>
				<div className={`${css.headButton}`}>
					<div
						onClick={() => setTerminalHeight(terminalHeight === 0 ? 1 : 0)}
						className={`${css.button} ${css.minimize}`}
					/>
				</div>
				<div className={`${css.headButton}`}>
					<div
						onClick={() => setTerminalHeight(terminalHeight === 2 ? 1 : 2)}
						className={`${css.button} ${css.expand}`}
					/>
				</div>
			</div>
			<div className={css.body}>
				<div
					ref={statusMessageContainerRef}
					className={css.innerContainer}
					style={{ maxHeight: TERMINAL_HEIGHTS[terminalHeight] }}
				>
					{deploymentEvents.map((item) => {
						return (
							<div key={item.eventId} className={css.statusMessage}>
								{item.message}
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

EnvironmentStatusOsxTerminal.propTypes = {
	deploymentEvents: PropTypes.array.required,
	closeOsxTerminal: PropTypes.func.required,
};
